import script from "./TokenAmounts.vue?vue&type=script&setup=true&lang=ts"
export * from "./TokenAmounts.vue?vue&type=script&setup=true&lang=ts"

import "./TokenAmounts.vue?vue&type=style&index=0&id=122a47d5&scoped=true&lang=css"

import exportComponent from "/Users/jason/u/acsi-ui-balancer-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-122a47d5"]])

export default __exports__